export default __webpack_public_path__ + "pgnv-assets/100f3a6cc4729ee5eefe3d3124fe86b8.png";